import { Component, OnInit, output, input, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentService, ApContentPipe } from '@ap/content';
import { ApPersistenceService } from '@ap/persistence';
import { ApButtonLinkComponent, ApButtonComponent } from '@ap/button';
import { ApCheckboxComponent } from '@ap/checkbox';

import { SignToken } from '../../sign.model';

import content from './selector.content.json';
import { ApTokenSelectorService } from './selector.service';
import { TokenType } from './selector.model';

/**
 * @ngdoc component
 * @name ApTokenSelectorComponent
 */
@Component({
    selector: 'ap-token-selector',
    standalone: true,
    templateUrl: './selector.component.html',
    styleUrls: ['./selector.component.scss'],
    providers: [ApTokenSelectorService, ApPersistenceService],
    imports: [ApButtonLinkComponent, ApButtonComponent, ApCheckboxComponent, FormsModule, ReactiveFormsModule, ApContentPipe]
})
export class ApTokenSelectorComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    /**
     * Required - Token types to select from
     */
    public readonly tokenTypes = input.required<TokenType[]>();

    /**
     * Optional formcontrol on which the selected token will be saved.
     */
    public readonly rememberControl = input<FormControl<boolean>>(null);

    /**
     * Emits when token is selected
     */
    public tokenSelected = output<SignToken[]>();

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public select(signToken: SignToken[]): void {
        this.tokenSelected.emit(signToken);
    }
}
